export var EAppointmentPaymentStatus = /*#__PURE__*/function (EAppointmentPaymentStatus) {
  EAppointmentPaymentStatus["Paid"] = "paid";
  EAppointmentPaymentStatus["PartiallyPaid"] = "partially-paid";
  return EAppointmentPaymentStatus;
}({});